import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import OrdersTable from "../components/tables/OrdersTable";

export default function OrdersPage() {
    return (
        <>
            <PageMeta
                title="Orders Management | Shoplattice Admin Dashboard"
                description="View and manage orders"
            />
            <PageBreadcrumb pageTitle="Orders" />
            <div className="space-y-6">
                <OrdersTable />
            </div>
        </>
    );
}
